// eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
const noop = (..._args: unknown[]) => {}

export { noop }
